const load = async () => document.fonts.ready;

export default load;
